'use client';

import { memo } from 'react';

import ErrorBoundary from '@Components/ErrorBoundary';
import SmartRender from '@Components/SmartRender';
import ProgressLine from './ProgressLine';
import SuccessSubscribeModalLoader from './SuccessSubscribeModalLoader';
import DiscountSubscriptionPopupLoader from './DiscountSubscriptionPopupLoader';

import type { FC } from 'react';

// TODO: Удалить этот ProgressLine после перехода на Next.js: там используется свой компонент

const LazyComponents: FC = () => {
  return (
    <ErrorBoundary>
      <ProgressLine />

      <SmartRender countries={['BLR']}>
        <DiscountSubscriptionPopupLoader />
      </SmartRender>

      <SuccessSubscribeModalLoader />
    </ErrorBoundary>
  );
};

export default memo(LazyComponents);
